module.exports = __webpack_public_path__ + "img/hennge_logo_black_vertical.96ae5840.svg";